import _defineProperty from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";
import React from "react";
var __jsx = React.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// eslint-disable-next-line import/no-extraneous-dependencies
import { yupResolver } from '@hookform/resolvers/yup';
import { useRouter } from 'next/router';
import { useMemo } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { FieldType, flattenFields, getBusinessValidationSchemaFromContentType } from '@uno/common-cms';
import { ImageFieldNames } from '@uno/common-shared';
import BackButton from 'components/common/BackButton';
import Paper from 'components/common/Paper';
import { PageLoader } from 'components/common/material-ui/custom-components';
import ContentForm from 'components/content/ContentForm';
import ContentSideBar from 'components/content/pages/content/edit/ContentSideBar';
import { usePageMetaData } from 'libs/content/hooks';
import { getValidateSchema } from 'redux/content';
import { DivContainer, FixedTopLeft, Form } from '../pages/content/edit/Edit.style';

var ContentFormWrapper = function ContentFormWrapper(_ref) {
  var contentType = _ref.contentType,
      firstLoadContent = _ref.firstLoadContent,
      loading = _ref.loading;

  var _useRouter = useRouter(),
      id = _useRouter.query.id;

  var validateSchema = useSelector(getValidateSchema);

  var _usePageMetaData = usePageMetaData(id),
      pageMetaData = _usePageMetaData.pageMetaData,
      pageMetaDataLoading = _usePageMetaData.loading,
      fetchPageMetaData = _usePageMetaData.fetchPageMetaData;

  var validationSchema = useMemo(function () {
    return getBusinessValidationSchemaFromContentType(contentType.name);
  }, [contentType]);
  var allFields = useMemo(function () {
    return contentType !== undefined ? flattenFields(contentType.fields) : [];
  }, [contentType]);
  var mapPropsToValues = useMemo(function () {
    var defaultValues = allFields.reduce(function (acc, _ref2) {
      var name = _ref2.name,
          type = _ref2.type,
          defaultValue = _ref2.defaultValue;

      if (type === FieldType.CoverImages) {
        return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, name, _defineProperty({}, ImageFieldNames.DEFAULT, defaultValue)));
      }

      return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, name, defaultValue));
    }, {});
    return _objectSpread(_objectSpread({}, defaultValues), firstLoadContent !== undefined ? firstLoadContent.contentData : {});
  }, [allFields, firstLoadContent]);
  var methods = useForm({
    defaultValues: mapPropsToValues,
    mode: 'onSubmit',
    resolver: validateSchema ? yupResolver(validationSchema) : undefined,
    context: {
      pageMetaData: pageMetaData
    },
    reValidateMode: 'onChange'
  });
  return __jsx(FormProvider, methods, __jsx(Form, null, __jsx(PageLoader, {
    open: loading || methods.formState.isSubmitting
  }), __jsx(Paper, {
    size: "small"
  }, __jsx(DivContainer, null, __jsx(FixedTopLeft, null, __jsx(BackButton, null)), __jsx(ContentForm, {
    contentType: contentType
  }))), __jsx(ContentSideBar, {
    content: firstLoadContent,
    pageMetaData: pageMetaData,
    pageMetaDataLoading: pageMetaDataLoading,
    fetchPageMetaData: fetchPageMetaData
  })));
};

export default ContentFormWrapper;